// extracted by mini-css-extract-plugin
export default {"container":"TextArea_container__b9HoI","label":"TextArea_label__MDL5P","input":"TextArea_input__hbw0+"};